import { IMappedNotificationBar } from '@hts/shared/types';
import { HtsButtonIcon, HtslIcon, LinkElement } from '@hts/shared/ui';
import { memo, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../../styles/Header/Mobile/MobileHeader.module.scss';
import { NotificationBar } from '../../NotificationBar';
import { MobileMenu } from './MobileMenu';
import { SearchMenu } from './SearchMenu';

interface IMobileHeaderProps {
  notificationBars: IMappedNotificationBar[];
}

export const MobileHeader: React.FC<IMobileHeaderProps> = memo(({ notificationBars }) => {
  const [isOpenBurgerMenu, setOpenMenu] = useState(false);
  const [isOpenSearchMenu, setOpenSearchMenu] = useState(false);

  const onOpenBurgerMenu = useCallback(() => setOpenMenu(true), []);
  const onCloseMenu = useCallback(() => setOpenMenu(false), []);

  const onOpenSearchMenu = useCallback(() => setOpenSearchMenu(true), []);
  const onCloseSearchMenu = useCallback(() => setOpenSearchMenu(false), []);

  return (
    <>
      <MobileMenu isOpen={isOpenBurgerMenu} onOpen={onOpenBurgerMenu} onClose={onCloseMenu} />

      <header className={styles.container}>
        <div className={styles.buttonsContainer}>
          <HtsButtonIcon onClick={onOpenBurgerMenu}>
            <HtslIcon icon="big-burger" />
          </HtsButtonIcon>

          <HtsButtonIcon onClick={onOpenSearchMenu}>
            <HtslIcon icon="search-bold" />
          </HtsButtonIcon>
        </div>

        <div className={styles.logoContainer}>
          <Link to="/">
            <img
              className={styles.logoImage}
              src="/assets/images/ihopetoseeyou-logo.png"
              alt="Ihopetoseeyou.com"
            />
          </Link>
        </div>

        <div className={styles.linksContainer}>
          <LinkElement type="help" colorType="black" isJustIconLayout />
          <LinkElement type="faq" colorType="black" isJustIconLayout />

          {/* <LinkElement type="help" colorType="black" isMobile /> */}
          {/* <LinkElement type="faq" colorType="black" isJustIconLayout /> */}
        </div>
      </header>

      <SearchMenu isOpen={isOpenSearchMenu} onOpen={onOpenSearchMenu} onClose={onCloseSearchMenu} />

      {notificationBars.length > 0 && <NotificationBar items={notificationBars} />}
    </>
  );
});
